/** @jsx tsx */
import { tsx } from "@dojo/framework/core/vdom";
import { WidgetBase } from "@dojo/framework/core/WidgetBase";
import { MAX_Z_INDEX } from "../../Constants";
import { IGuide } from "../interfaces/model/Guides";
import { stateConstants } from "../selectors/index";
import { Guide } from "./Guide";

/**
 *  Guide overlay render properties
 */
export interface IGuidesOverlayProps {
    guides: IGuide[];
}

/**
 * Guides Overlay.
 * Provides base component for rendering guide lines
 */
export class GuidesOverlay extends WidgetBase<IGuidesOverlayProps> {
	/**
     * Override WidgetBase#render to produce a virtual DOM tree.
     * @returns {HNode} Each time render() executes, it should build the entire virtual DOM tree.
     */
	protected render() {
		const { guides } = this.properties;
		const children = guides.map((guide, index) => {
			if (guide) {
				return (
					<Guide
						key={index}
						x1={guide.x1}
						x2={guide.x2}
						y1={guide.y1}
						y2={guide.y2}
					/>
				);
			}
		});
		const { editorWidth, editorHeight } = stateConstants().canvasDimension;
		return (
			<div classes={["c8_canvas_page", "c8_canvas_overlay"]} styles={{ zIndex: `${MAX_Z_INDEX}` }}>
				<svg
					height={`${editorHeight}`}
					preserveAspectRatio="xMinYMin"
					width={`${editorWidth}`}
					xlink="http://www.w3.org/1999/xlink"
					xml="http://www.w3.org/XML/1998/namespace"
					xmlns="http://www.w3.org/2000/svg"
				>
					{children}
				</svg>
			</div>
		);
	}
}

export default GuidesOverlay;
